var React = require('react');

function LevelDownAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M152 352V80H68a12 12 0 0 1-8.48-3.52l-56-56A12 12 0 0 1 12 0h196a24 24 0 0 1 24 24v328z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M296 352c20.87 0 31.85 25 17.58 40.33l-104 112a24 24 0 0 1-33.91 1.26c-.44-.4-.86-.83-1.26-1.26l-104-112C56.25 377 67.07 352 88 352z","className":"fa-primary","key":2})]);
}

LevelDownAlt.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = LevelDownAlt;

LevelDownAlt.default = LevelDownAlt;
